import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 0, label: "Em digitação" },
    { value: 1, label: "Pendente de homologação" },
    { value: 2, label: "Revisão" },
    { value: 3, label: "Revisão interna" },
    { value: 4, label: "Homologado" },
    { value: 5, label: "Cancelado" },
    { value: 6, label: "Inativo" },
    { value: 7, label: "Arquivado" }
];

const SituacaoOcupante = ({ field, placeholder, name, id, disabled=false }) => {
    return (
        <Select 
            options={options} 
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
        />
    )
}

export { SituacaoOcupante, options as OpcoesSituacaoOcupante }